module.exports = __webpack_public_path__ + "img/02ae0f4f-26d0-468d-8b7d-4cb9677c9760.c2d2a491.svg";